import React, { useEffect, useState } from "react";
import FontDescription from "./FontDescription";
import fontImg from "../../assets/images/service/s7.png";
import FontEx from "./FontEx";
import TestApiModal from "../../component/modal/TestApiModal";
import TestAPiMobileModal from "../../component/modal/TestApiMobileModal";
const FontService = () => {
  const [showModal, setShowModal] = useState(false);
  const [showMobileModal, setShowMobileModal] = useState(false);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    // 이벤트 리스너 등록
    window.addEventListener("resize", handleResize);

    // cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleModalControler = () => {
    if (windowWidth >= 701) {
      setShowModal(true);
    } else {
      setShowMobileModal(true);
    }
  };

  return (
    <>
      <div
        className="row my-5 sercice-details-content align-items-center"
        id="font"
      >
        <div className="col-lg-6 col-12 order-2 order-lg-1">
          <div className="details mt_md--30 mt_sm--30">
            <h4 className="title">세체인식 API</h4>
            <p>
              이미지 내 텍스트를 OCR을 활용하여 텍스트 인식 후 추룰된 텍스트에
              대하여 해당 텍스트의 폰트 종류를 찾아주는 기술입니다.
            </p>
            <ul className="liststyle mt-4">
              <li>
                1000종류 이상의 서체(Font)를 학습하여 다양한 텍스트에 대해
                서체인싱이 가능한 AI 모델
              </li>
              <li>이미지 내 텍스트를 추출하는 OCR 기술과 연동하여 활용</li>
              <li>디자인 과련 웹/앱 서비스에 활용 가능</li>
            </ul>
          </div>
          <div
            className="slide-btn mt-2"
            style={{
              cursor: `pointer`,
            }}
          >
            <a href="/border" className="rn-button-style--2 btn-primary-color">
              문의하기
            </a>
          </div>
        </div>
        <div className="col-lg-6 col-12 order-1 order-lg-2">
          <div className="thumb position-relative">
            <img className="w-100" src={fontImg} alt="Service Images" />
            {/* <ModalVideo
                    channel="youtube"
                    isOpen={this.state.isOpen}
                    videoId="ZOoVOfieAF8"
                    onClose={() => this.setState({ isOpen: false })}
                    />
                    <button
                    className="video-popup"
                    onClick={this.openModal}
                    > */}
            {/* <span className="play-icon"></span>
                    </button> */}
          </div>
        </div>
      </div>
      <FontDescription></FontDescription>
      <TestApiModal isOpen={showModal} onClose={() => setShowModal(false)} />
      <TestAPiMobileModal
        isOpen={showMobileModal}
        onClose={() => setShowMobileModal(false)}
      />
      <div className="row sercice-details-content pb--80 align-items-center">
        <FontEx></FontEx>
      </div>
    </>
  );
};
export default FontService;
